import * as stylex from "@stylexjs/stylex";

export function SearchGlyph() {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth={1}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...stylex.props(styles.glyph)}
    >
      <circle cx="7" cy="7" r="4.5" />
      <path d="M10.4 10.4 13.5 13.5" />
    </svg>
  );
}

const styles = stylex.create({ glyph: { flexShrink: 0 } });
